import "core-js/stable";
import "regenerator-runtime";


// Change check button text

document.addEventListener('DOMContentLoaded', () =>{

const isH5P = document.getElementsByClassName('h5p-iframe-wrapper');
if (!isH5P)
    return;

function getFrames() {
    const iframes = document.getElementsByClassName('h5p-iframe');
    
    if (!iframes || iframes.length == 0) {
        setTimeout(function() {
            getFrames();
            return;
        } , 1000)
    } else {
        getButtons(iframes);
    }
}

function getButtons(iframes) {
    let H5P_answer_buttons = [];

    for(let i = 0; i < iframes.length; i++) {
        const buttons = iframes[i].contentWindow.document.getElementsByClassName('h5p-question-check-answer');
        if (!buttons || buttons.length == 0){
            setTimeout(function() {
                getButtons(iframes);
                return;
            } , 1000)
        } else {
            [].forEach.call(buttons, button => {
                H5P_answer_buttons.push(button);
            })
    
        }
    }

    for (let i = 0; i < H5P_answer_buttons.length; i++) {
        H5P_answer_buttons[i].innerText = "Sla antwoord op";
    }
}
getFrames();
})

function CourseCompleteFix() {
    var target = document.querySelector(".ld-focus-content .wpProQuiz_content .wpProQuiz_sending");
    var results = document.querySelector(".ld-focus-content .wpProQuiz_content .wpProQuiz_results");

    var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutationRecord) {
            results.style.display = "block";
        });
    });

    observer.observe(target, {
        attributes: true,
        attributeFilter: ['style']
    })
}
window.onload = CourseCompleteFix;